import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { ModalpopService } from '../modalpop.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-user-master',
  templateUrl: './user-master.component.html',
  styleUrls: ['./user-master.component.scss']
})
export class UserMasterComponent implements OnInit {
  userForm: FormGroup;
  submitpayload: any;
  dialogRef: MatDialogRef<any>;
  userList: any;
  userData: any;
  constructor(public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private fb: FormBuilder, public router: Router, private httpClient: HttpClient,
    private route: ActivatedRoute, private spinner: NgxSpinnerService,) { }

  ngOnInit(): void {
    this.userForm = this.fb.group({
      LoginEmail: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-z0-9 - &\\s]*$')]),
      LoginName: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-z0-9 - &\\s]*$')])
    })

    this.getUserData()

  }


  saveUser() {
    this.spinner.show();
    this.submitpayload = this.userForm.value;
    this.umsService.addUserForPermission(this.submitpayload).subscribe(res => {
      sessionStorage.setItem('UserName', 'LoginName');
      this.spinner.hide();
      if (res.status) {
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.userForm.reset();
      } else {
        this.spinner.hide();
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-box-open'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }



  getUserData() {
    let param = 0;
    //     this.umsService.getUsers(param).subscribe((res) => {
    //       this.userData = res.data[0];

    //     });
  }

  prepopulateData(id) {
    this.spinner.show();
    let payload = id.LoginId;
    sessionStorage.clear();
    localStorage.clear();
    this.umsService.getOneUsers(payload).subscribe((res) => {
      if (res.status) {
        let data = res.data[0][0];
        sessionStorage.setItem('loginId', data.LoginId)
        sessionStorage.setItem('loginName', data.LoginFullName)
        this.spinner.hide();
        this.userForm = this.fb.group({
          LoginEmail: new FormControl(data.LoginName),
          LoginName: new FormControl(data.LoginFullName),
        });

      } else {
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-box-open'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

      }

    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-box-open'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }


}
